import { AppBar, Box, styled, Toolbar, Link } from "@mui/material";
import { H6 } from "./Typography";
// root component interface
type DashboardNavBarProps = {
  userImages?: string;
};

// custom styled components
const FooterRoot = styled(AppBar)(() => ({
  zIndex: 11,
  backdropFilter: "blur(6px)",
  marginTop: 10,
  boxShadow: "0px 4px 5px -2px rgba(0,0,0,0.1)",
}));

const StyledToolBar = styled(Toolbar)(() => ({
  "@media (min-width: 0px)": {
    paddingRight: 80,
    background: "#332C2C",
  },
}));

// root component
function Footer({ userImages }: DashboardNavBarProps) {
  return (
    <FooterRoot position="sticky">
      <StyledToolBar
        sx={{
          paddingLeft: {
            xs: 0,
          },
          paddingRight: {
            xs: 0,
          },
          display: "flex",
          flexDirection: {
            md: "row",
            xs: "column",
          },
          pt: {
            md: 0,
            xs: 2,
          },
          pb: {
            md: 0,
            xs: 2,
          },
        }}
      >
        <Box
          sx={{
            flexDirection: {
              md: "row",
              xs: "column",
            },
            display: "flex",
            justifyContent: "space-between",
            width: {
              md: "60%",
              xs: "100%",
            },
            paddingLeft: {
              md: 10,
              xs: 0,
            },
          }}
        >
          <Link
            href={process.env.REACT_APP_AboutUS}
            target="_blank"
            sx={linkStyle}
          >
            <H6 sx={textStyle} fontWeight={500}>
              About ACRU
            </H6>
          </Link>
          <Link
            href={process.env.REACT_APP_TermsAndConditions}
            target="_blank"
            sx={linkStyle}
          >
            <H6 sx={textStyle} fontWeight={500}>
              Terms & Conditions
            </H6>
          </Link>
          <Link
            href={process.env.REACT_APP_PrivacyAndPolicy}
            target="_blank"
            sx={linkStyle}
          >
            <H6 sx={textStyle} fontWeight={500}>
              Privacy Policy
            </H6>
          </Link>
          <Link
            href={process.env.REACT_APP_CancellationAndRefundPlicy}
            target="_blank"
            sx={linkStyle}
          >
            <H6 sx={textStyle} fontWeight={500}>
              Cancellation & Refund Policy
            </H6>
          </Link>
        </Box>
        <Box
          sx={{
            flexDirection: {
              md: "row",
              xs: "column",
            },
            display: "flex",
            justifyContent: "flex-end",
            width: {
              md: "40%",
              xs: "100%",
            },
            paddingRight: {
              md: 10,
              xs: 0,
            },
          }}
        >
          <H6 sx={textStyle} fontWeight={500}>
            Acru® | All Rights Reserved | Copyright 2023
          </H6>
        </Box>
      </StyledToolBar>
    </FooterRoot>
  );
}

export default Footer;
const textStyle = {
  textAlign: "center",
  fontFamily: "'Poppins', sans-serif",
  color: "#fff",
  mt: {
    md: 0,
    xs: 0.5,
  },
};
const linkStyle = {
  cursor: "pointer",
  textDecoration: "none",
};
